import { useEffect, useState } from 'react';

/** Tailwind's `md` breakpoint — below this we're in the mobile layout. */
const MOBILE_QUERY = '(max-width: 767px)';

/**
 * True while the viewport is phone-sized. Unlike the ad-hoc
 * `window.innerWidth < 768` checks elsewhere in the app, this subscribes to the
 * media query, so rotating a device or resizing a window updates the layout.
 */
export function useIsMobileViewport(): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(MOBILE_QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const query = window.matchMedia(MOBILE_QUERY);
    const onChange = (event: MediaQueryListEvent) => setIsMobile(event.matches);
    setIsMobile(query.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
